import * as yup from 'yup';

// Valid type values for dadeviation/init endpoint
const VALID_DEVIATION_TYPES = [
  'art',
  'journal',
  'commission',
  'status-update',
  'poll',
  'tier',
] as const;

// Yup schema for dadeviation/init request validation
const daDeviationInitValidationSchema = yup.object({
  deviationid: yup
    .number()
    .integer('Deviation ID must be an integer')
    .required('Deviation ID is required'),
  username: yup.string().required('Username is required'),
  comments_cursor: yup.string().optional(),
  type: yup
    .string()
    .oneOf(
      VALID_DEVIATION_TYPES as any,
      `Type must be one of: ${VALID_DEVIATION_TYPES.join(', ')}`
    )
    .required('Type is required')
    .test('type-not-empty', 'Type cannot be empty', value => {
      return value !== undefined && value !== null && value !== '';
    }),
  preload: yup.boolean().optional(),
  current_id: yup.number().integer().optional(),
  include_session: yup.boolean().optional(),
});

/**
 * Validates dadeviation/init request data using Yup schema
 * Based on papiRequestDaDeviationInitSchema
 * @param data The request data to validate
 * @returns boolean indicating if validation passed
 */
export function validateDaDeviationInitRequest(data: any): boolean {
  try {
    daDeviationInitValidationSchema.validateSync(data, { abortEarly: false });
    return true;
  } catch (error) {
    return false;
  }
}
